export default __webpack_public_path__ + "static/media/placeholder.c5117e9a.png";